// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvas-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(135deg, #4B0082, #800080);
    min-height: 100vh;
    color: white;
    font-family: 'Arial', sans-serif;
}

.navbar {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px;
    background-color: rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.navbar button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
    cursor: pointer;
    transition: background 0.3s;
}

.navbar button:hover {
    background-color: rgba(255, 255, 255, 0.3);
}

.color-selection {
    display: flex;
}

.color-selection button {
    width: 30px;
    height: 30px;
    border: none;
    border-radius: 50%;
    margin-left: 10px;
    cursor: pointer;
}

.canvas {
    border: 1px solid white;
    margin-top: 20px;
}

@media (max-width: 600px) {
    .canvas {
        height: 300px; /* Уменьшение высоты канваса для мобильных */
    }

    .navbar {
        flex-direction: column;
        align-items: center;
    }

    .navbar button {
        margin: 5px 0; /* Уменьшение отступа между кнопками */
    }
}

/* Стили для панели управления доступом */
.access-panel {
    width: 250px;
    background-color: #16213e;
    padding: 1rem;
    border-radius: 8px;
    border: 1px solid #4a148c;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.access-panel h3 {
    margin-top: 0;
    color: #b388ff;
    border-bottom: 1px solid #4a148c;
    padding-bottom: 0.5rem;
}

/* Форма добавления пользователя */
.add-user-form {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

.add-user-form input {
    flex-grow: 1;
    padding: 0.5rem;
    background-color: #0f3460;
    border: 1px solid #4a148c;
    border-radius: 4px;
    color: white;
}

.add-user-form button {
    padding: 0.5rem 1rem;
    background-color: #4a148c;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.add-user-form button:hover {
    background-color: #6a1b9a;
}

/* Список пользователей */
.users-list {
    max-height: 400px;
    overflow-y: auto;
}

.user-item {
    display: flex;
    align-items: center;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
    background-color: #0f3460;
    border-radius: 4px;
    gap: 0.5rem;
}

/* Аватар пользователя */
.user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #b388ff;
}

.username {
    flex-grow: 1;
    color: #e6e6e6;
}

/* Кнопка удаления */
.remove-btn {
    background: none;
    border: none;
    color: #ff5252;
    font-size: 1.2rem;
    cursor: pointer;
    padding: 0 0.5rem;
    transition: all 0.2s;
}

.remove-btn:hover {
    color: #ff1744;
    transform: scale(1.2);
}

/* Сообщение об ошибке */
.access-error {
    color: #ff5252;
    padding: 1rem;
    background-color: #0f3460;
    border-radius: 4px;
    margin: 1rem;
    text-align: center;
}

/* Контейнер для canvas и панели */
.canvas-container {
    display: flex;
    justify-content: center;
    gap: 2rem;
    padding: 1rem;
    flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/style/canvas.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qDAAqD;IACrD,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,0CAA0C;IAC1C,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa,EAAE,4CAA4C;IAC/D;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,aAAa,EAAE,sCAAsC;IACzD;AACJ;;AAEA,yCAAyC;AACzC;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,YAAY;AAChB","sourcesContent":[".canvas-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: linear-gradient(135deg, #4B0082, #800080);\n    min-height: 100vh;\n    color: white;\n    font-family: 'Arial', sans-serif;\n}\n\n.navbar {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    padding: 20px;\n    background-color: rgba(255, 255, 255, 0.1);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.navbar button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    background-color: rgba(255, 255, 255, 0.2);\n    color: white;\n    cursor: pointer;\n    transition: background 0.3s;\n}\n\n.navbar button:hover {\n    background-color: rgba(255, 255, 255, 0.3);\n}\n\n.color-selection {\n    display: flex;\n}\n\n.color-selection button {\n    width: 30px;\n    height: 30px;\n    border: none;\n    border-radius: 50%;\n    margin-left: 10px;\n    cursor: pointer;\n}\n\n.canvas {\n    border: 1px solid white;\n    margin-top: 20px;\n}\n\n@media (max-width: 600px) {\n    .canvas {\n        height: 300px; /* Уменьшение высоты канваса для мобильных */\n    }\n\n    .navbar {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .navbar button {\n        margin: 5px 0; /* Уменьшение отступа между кнопками */\n    }\n}\n\n/* Стили для панели управления доступом */\n.access-panel {\n    width: 250px;\n    background-color: #16213e;\n    padding: 1rem;\n    border-radius: 8px;\n    border: 1px solid #4a148c;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.access-panel h3 {\n    margin-top: 0;\n    color: #b388ff;\n    border-bottom: 1px solid #4a148c;\n    padding-bottom: 0.5rem;\n}\n\n/* Форма добавления пользователя */\n.add-user-form {\n    display: flex;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n}\n\n.add-user-form input {\n    flex-grow: 1;\n    padding: 0.5rem;\n    background-color: #0f3460;\n    border: 1px solid #4a148c;\n    border-radius: 4px;\n    color: white;\n}\n\n.add-user-form button {\n    padding: 0.5rem 1rem;\n    background-color: #4a148c;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.add-user-form button:hover {\n    background-color: #6a1b9a;\n}\n\n/* Список пользователей */\n.users-list {\n    max-height: 400px;\n    overflow-y: auto;\n}\n\n.user-item {\n    display: flex;\n    align-items: center;\n    padding: 0.5rem;\n    margin-bottom: 0.5rem;\n    background-color: #0f3460;\n    border-radius: 4px;\n    gap: 0.5rem;\n}\n\n/* Аватар пользователя */\n.user-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 2px solid #b388ff;\n}\n\n.username {\n    flex-grow: 1;\n    color: #e6e6e6;\n}\n\n/* Кнопка удаления */\n.remove-btn {\n    background: none;\n    border: none;\n    color: #ff5252;\n    font-size: 1.2rem;\n    cursor: pointer;\n    padding: 0 0.5rem;\n    transition: all 0.2s;\n}\n\n.remove-btn:hover {\n    color: #ff1744;\n    transform: scale(1.2);\n}\n\n/* Сообщение об ошибке */\n.access-error {\n    color: #ff5252;\n    padding: 1rem;\n    background-color: #0f3460;\n    border-radius: 4px;\n    margin: 1rem;\n    text-align: center;\n}\n\n/* Контейнер для canvas и панели */\n.canvas-container {\n    display: flex;\n    justify-content: center;\n    gap: 2rem;\n    padding: 1rem;\n    flex-grow: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
